import { Modal, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Speech from "speak-tts";

const TextReaderPopup = ({ textReaderShowHide, handleTextReaderShowHide }) => {
  const [voice, setVoice] = useState({});
  const [selectedVoiceLang, setSelectedVoiceLang] = useState("en-GB");
  const [speechInstance, setSpeechInstance] = useState(null);

  useEffect(() => {
    const speech = new Speech();
    speech
      .init()
      .then((data) => {
        setVoice(data);
        setSpeechInstance(speech);
      })
      .catch((e) => {
        console.error("An error occurred while initializing: ", e);
      });
  }, []);

  const handleVoiceChange = (event) => {
    setSelectedVoiceLang(event.target.value);
  };

  return (
    <Modal show={textReaderShowHide} size="lg" dialogClassName="modalLeftRight modalRight">
      <Modal.Header closeButton onClick={handleTextReaderShowHide}>
        <Modal.Title>Text Reader</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-secondary">
        <div className="row">
          <div className="col-md-12 form-group">
            <label htmlFor="voiceLang" className="form-control-label">
              Language
            </label>
            <select
              name="voiceLang"
              id="voiceLang"
              className="form-control"
              onChange={handleVoiceChange}
              value={selectedVoiceLang}
            >
              {voice.voices?.map((vs, index) => (
                <option key={index} value={vs.lang}>{vs.name}</option>
              ))}
            </select>
          </div>
          <div className="col-6">
            <label htmlFor="pitch" className="form-control-label">
              Pitch
            </label>
            <input type="number" className="form-control" id="pitch" name="pitch" value={voice.pitch || 1} readOnly />
          </div>
          <div className="col-6">
            <label htmlFor="rate" className="form-control-label">
              Rate
            </label>
            <input type="number" className="form-control" id="rate" name="rate" value={voice.rate || 1} readOnly />
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer className="justify-content-center">
        <Button variant="danger" onClick={handleTextReaderShowHide}>
          <i className="fa fa-times" aria-hidden="true"></i> Close
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default TextReaderPopup;
